import { render, staticRenderFns } from "./homeworkDetail.vue?vue&type=template&id=232312c5&scoped=true"
import script from "./homeworkDetail.vue?vue&type=script&lang=js"
export * from "./homeworkDetail.vue?vue&type=script&lang=js"
import style0 from "./homeworkDetail.vue?vue&type=style&index=0&id=232312c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232312c5",
  null
  
)

export default component.exports